import { render } from "./FlowLoader.vue?vue&type=template&id=3fff5622&scoped=true&ts=true"
import script from "./FlowLoader.vue?vue&type=script&lang=ts"
export * from "./FlowLoader.vue?vue&type=script&lang=ts"

import "./FlowLoader.vue?vue&type=style&index=0&id=3fff5622&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fff5622"]])

export default __exports__